import { Component } from 'react'
import { connect } from 'react-redux'
import { clearSubmitErrors } from 'redux-form'

import { trackEvent } from '@offerzen/pinata-shame'

import {
  fetchEducation as reduxFetchEducation,
  addBlankEducationItem as reduxAddBlankEducationItem,
  deleteBlankEducationItem as reduxDeleteBlankEducationItem,
  createEducation as reduxCreateEducation,
  updateEducation as reduxUpdateEducation,
  deleteEducation as reduxDeleteEducation,
  toggleEducationEdit as reduxToggleEducationEdit,
  searchUniversities as reduxSearchUniversities,
  searchDegrees as reduxSearchDegrees,
  submit as reduxSubmit,
} from '../../redux/modules/education'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'

import { educationList, hasEducationRecords, isAddingNewEducation } from '../../selectors/education'

class Education extends Component {
  componentDidMount() {
    this.props.updateProgress(83)
    trackEvent('onboarding-education-accessed')
    this.props.fetchEducation()
  }

  render() {
    const { children, ...rest } = this.props
    return children({ ...rest })
  }
}

const mapStateToProps = state => ({
  candidateId: state.candidate.id,
  candidate: state.candidate,
  loading: state.education.fetching,
  educations: educationList(state),
  hasEducationRecords: hasEducationRecords(state),
  isAddingNewEducation: isAddingNewEducation(state),
})

const mapDispatchToProps = dispatch => ({
  fetchEducation: candidateId => dispatch(reduxFetchEducation(candidateId)),
  addBlankEducation: () => {
    const uniqueId = Date.now().toString()
    dispatch(reduxAddBlankEducationItem(uniqueId))
  },
  deleteBlankEducation: tempId => dispatch(reduxDeleteBlankEducationItem(tempId)),
  createEducation: (candidateId, data, resolve, reject) => dispatch(reduxCreateEducation(candidateId, data, resolve, reject)),
  updateEducation: (id, data, resolve, reject) => dispatch(reduxUpdateEducation(id, data, resolve, reject)),
  deleteEducation: (candidateId, id) => dispatch(reduxDeleteEducation(candidateId, id)),
  toggleEditing: (id, editing) => dispatch(reduxToggleEducationEdit(id, editing)),
  searchUniversities: (id, term) => dispatch(reduxSearchUniversities(id, term)),
  searchDegrees: (id, term) => dispatch(reduxSearchDegrees(id, term)),
  clearTopLevelErrors: () => dispatch(clearSubmitErrors('educationListForm')),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
  submitEducation: (data, resolve, reject) => dispatch(reduxSubmit(data, resolve, reject)),
  trackEducationChange: (action, incomplete = undefined) => {
    trackEvent('Candidate: profile action', {
      source: 'onboarding',
      action,
      incomplete,
    })
  },
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  addBlankEducation: () => {
    dispatchProps.addBlankEducation()
    dispatchProps.clearTopLevelErrors()
  },
  fetchEducation: () => dispatchProps.fetchEducation(stateProps.candidateId),
  createEducation: (data, resolve, reject) => dispatchProps.createEducation(stateProps.candidateId, data, resolve, reject),
  updateEducation: (id, data, resolve, reject) => {
    dispatchProps.updateEducation(id, data, resolve, reject)
    dispatchProps.clearTopLevelErrors()
    dispatchProps.trackEducationChange('updated education')
  },
  deleteEducation: data => {
    dispatchProps.deleteEducation(stateProps.candidateId, data.id)
    dispatchProps.trackEducationChange('removed education', data.missingInformation)
    dispatchProps.clearTopLevelErrors()
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Education)
